// extracted by mini-css-extract-plugin
export default {"navigationLogo":"NavigationLogo_navigationLogo__lr3Dp"};